import { MapPin, Navigation } from "lucide-react";
import Reveal from "./Reveal";
import { AREAS, MAPS_URL } from "./data";

export default function ServiceAreas() {
  return (
    <section id="areas" data-testid="service-areas-section" className="bg-sapphire-ink py-16 sm:py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-whatsapp">Service Areas</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Proudly serving Siliguri &amp; North Bengal
          </h2>
          <p className="mt-5 max-w-lg text-sm leading-relaxed text-white/70 sm:text-base">
            Based at Bankim Nagar, our crews cover every major neighbourhood in Siliguri — and travel to Bagdogra and
            Jalpaiguri for larger residential, commercial and post-construction projects.
          </p>
          <div className="mt-8 flex flex-wrap gap-x-10 gap-y-4">
            {[
              ["12+", "Neighbourhoods covered"],
              ["Same week", "Slot availability"],
              ["Free", "On-site quotation"],
            ].map(([v, l]) => (
              <div key={l}>
                <p className="text-2xl font-extrabold tracking-tight text-white">{v}</p>
                <p className="text-xs font-semibold uppercase tracking-[0.15em] text-white/50">{l}</p>
              </div>
            ))}
          </div>
          <a
            data-testid="service-areas-directions-link"
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-bold text-white transition-all duration-300 hover:border-whatsapp hover:text-whatsapp"
          >
            <Navigation className="h-4 w-4" />
            Get directions to our office
          </a>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="flex flex-wrap gap-3">
            {AREAS.map((a, i) => (
              <span
                key={a}
                data-testid={`area-chip-${a.toLowerCase().replace(/\s+/g, "-")}`}
                className={`inline-flex items-center gap-2 rounded-full border px-5 py-2.5 text-sm font-semibold transition-colors duration-300 ${
                  i === 5
                    ? "border-whatsapp bg-whatsapp/10 text-whatsapp"
                    : "border-white/15 bg-white/5 text-white/85 hover:border-white/40"
                }`}
              >
                <MapPin className="h-4 w-4" />
                {a}
                {i === 5 && <span className="text-[10px] font-bold uppercase tracking-widest">HQ</span>}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
